import { WORKFLOW_DATA_SOURCES, ACTION_OUTPUTS, ENROLLED_OBJECT, ENROLLMENT_EVENTS, FETCHED_OBJECTS, ENROLLMENT_DATASET } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
export const DEFAULT_ALLOWED_DATA_SOURCES = [ENROLLED_OBJECT, FETCHED_OBJECTS, ENROLLMENT_EVENTS, ENROLLMENT_DATASET, ACTION_OUTPUTS];
/**
 * Determine if the provided data source should be allowed based on its prefix.
 */
export const isDataSourceAllowListed = ({
  dataSourceAllowList,
  prefix
}) => {
  // WORKFLOW_DATA_SOURCES is always allowed.
  if (prefix === WORKFLOW_DATA_SOURCES) return true;
  // Nothing to check against so default to it being allowed.
  if (!dataSourceAllowList || !dataSourceAllowList.length) return true;
  return dataSourceAllowList.some(dataSource => prefix.startsWith(dataSource));
};